import React, { Component } from "react";
import { CapitalizeWord, CallAPI, parseIntFromStr, GetCookieFunction, BirthdayToAge } from '../../utils/util';
import { PatientOptions } from './patientOptions';

class PatientNav extends Component {
    constructor(props) {
        super(props);
        this.patientId = parseIntFromStr(this.props.patientId);
        this.userType = (GetCookieFunction("User") ? GetCookieFunction("User").type : "");
        this.state = {
            patientInfo: {},
            checkedIn: false,
            dialysisStarted: false
        };
    }

    componentDidMount() {
        if (this.patientId > 0) {
            CallAPI({}, `patients/${this.patientId}/basic`, 'GET', (res) => {
                this.setState({ patientInfo: res });
            });
            CallAPI({}, `patients/${this.patientId}/checkinStatus`, 'GET', (res) => {
                if (res) {
                    this.setState({
                        checkedIn: res.checkedIn,
                        dialysisStarted: res.dialysisStarted
                    });
                }
            });
        }
    }

    getHamburger = () => {
        if (this.userType !== "doctor") return null;
        return (
            <div>
                <input id="toggle" type="checkbox" />
                <label htmlFor="toggle" className="hamburger">
                    <div className="top-bun"></div>
                    <div className="meat"></div>
                    <div className="bottom-bun"></div>
                </label>
                <div className="nav">
                    <label htmlFor="toggle" className="nav-backdrop" />
                    <div className="nav-wrapper">
                        <label htmlFor="toggle" className="nav-close-btn" aria-label="Close menu">✕</label>
                        <nav>
                            <a href={`/patients/${this.patientId}/profile`}>Patient Profile</a>
                            <a href={`/patients/${this.patientId}/familySocialHistory`}>Medical History</a>
                            <a href={`/patients/${this.patientId}/dialysisorder`}>Dialysis Order</a>
                            <a href={`/patients/${this.patientId}/allergies`}>Allergies</a>
                            <a href={`/patients/${this.patientId}/medications`}>Medication</a>
                            <a href={`/patients/${this.patientId}/surgeries`}>Surgeries</a>
                            <a href={`/patients/${this.patientId}/assessmentPlan`}>Assessment &amp; Plan</a>
                            <a href={`/patients/${this.patientId}/notes/1`}>Treatment Notes</a>
                        </nav>
                    </div>
                </div>
            </div>
        );
    };

    render = () => {
        if (this.patientId === 0) return null;

        const { patientInfo, checkedIn, dialysisStarted } = this.state;

        return (
            <div className="subNav">
                {this.getHamburger()}

                <div className="subNavPatientInfo">
                    <b>{patientInfo.fName} {patientInfo.lName}</b>
                    {(patientInfo.bDay || patientInfo.age != null) && (
                        <span className="subNavPatientMeta">
                            &nbsp;·&nbsp; Age {BirthdayToAge(patientInfo.bDay, patientInfo.age)} &nbsp;·&nbsp; {CapitalizeWord(patientInfo.gender)}
                        </span>
                    )}
                </div>

                <div className="subNavActions">
                    <PatientOptions
                        patientId={this.patientId}
                        checkedIn={checkedIn}
                        dialysisStarted={dialysisStarted}
                    />
                </div>
            </div>
        );
    };
}

export { PatientNav };
